import { Routes } from '@angular/router';

export const routes: Routes = [

    {
        path:'',
         loadChildren:() => import('./web/web.module').then(m => m.WebModule)
    }
];
